import React, { useEffect, useState } from 'react'
import { useColorScheme, useTheme } from '@mui/material/styles'
import { IconButton, styled } from '@mui/material'
import { useSettingsContext } from '@/components/settings'

const StyledIconButton = styled(IconButton)(({ theme }) => ({
  width: 40,
  height: 40,
  borderRadius: '50%',
  transition: 'all 0.3s ease-in-out',
  backgroundColor: 'transparent',
  '&:hover': {
    backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[600] : theme.palette.grey[300],
    boxShadow: theme.shadows[4],
    transform: 'scale(1.1)',
  },
  '& svg': {
    transition: 'all 0.3s ease-in-out',
  },
}))

const LightDarkSwitch = () => {
  const theme = useTheme()
  const settings = useSettingsContext()
  const { mode, setMode } = useColorScheme()
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  useEffect(() => {
    if (!mounted) return
    if (!mode) return
    document.documentElement.setAttribute('data-mode', mode)
    document.documentElement.setAttribute('data-sidebar', mode)
    document.documentElement.setAttribute('data-topbar', mode)
  }, [mode, mounted])

  const handleToggle = () => {
    const newMode = mode === 'light' ? 'dark' : 'light'
    settings.onUpdateField('colorScheme', newMode)
    setMode(newMode)
  }

  const isDark = mode === 'dark'

  if (!mounted) {
    return (
      <StyledIconButton
        aria-label="Loading color mode"
        disabled
        sx={{ opacity: 0.65 }}
      />
    )
  }

  return (
    <StyledIconButton
      onClick={handleToggle}
      aria-label={`Switch to ${isDark ? 'light' : 'dark'} mode`}
    >
      {isDark ? (
        <svg
          width="20"
          height="20"
          fill="#42A5F5"
          viewBox="0 0 24 24"
        >
          <path fillRule="evenodd" d="M9.528 1.718a.75.75 0 01.162.819A8.97 8.97 0 009 6a9 9 0 009 9 8.97 8.97 0 003.463-.69.75.75 0 01.981.98 10.503 10.503 0 01-9.694 6.46c-5.799 0-10.5-4.701-10.5-10.5 0-4.368 2.667-8.112 6.46-9.694a.75.75 0 01.818.162z" clipRule="evenodd" />
        </svg>
      ) : (
        <svg
          width="20"
          height="20"
          fill="#FFA726"
          viewBox="0 0 24 24"
        >
          <path d="M12 2.25a.75.75 0 01.75.75v2.25a.75.75 0 01-1.5 0V3a.75.75 0 01.75-.75zM7.5 12a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0zM18.894 6.166a.75.75 0 00-1.06-1.06l-1.591 1.59a.75.75 0 101.06 1.061l1.591-1.59zM21.75 12a.75.75 0 01-.75.75h-2.25a.75.75 0 010-1.5H21a.75.75 0 01.75.75zM17.834 18.894a.75.75 0 001.06-1.06l-1.59-1.591a.75.75 0 10-1.061 1.06l1.59 1.591zM12 18a.75.75 0 01.75.75V21a.75.75 0 01-1.5 0v-2.25A.75.75 0 0112 18zM7.758 17.303a.75.75 0 00-1.061-1.06l-1.591 1.59a.75.75 0 001.06 1.061l1.591-1.59zM6 12a.75.75 0 01-.75.75H3a.75.75 0 010-1.5h2.25A.75.75 0 016 12zM6.697 7.757a.75.75 0 001.06-1.06l-1.59-1.591a.75.75 0 00-1.061 1.06l1.59 1.591z" />
        </svg>
      )}
    </StyledIconButton>
  )
}

export default LightDarkSwitch
